module.exports = __webpack_public_path__ + "img/gk2.4f8744f5.png";